var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cursor-pointer",on:{"click":_vm.clickHandler}},[_c('Icon',{attrs:{"name":"copy","width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }